import { Routes, Route, useLocation } from 'react-router-dom';

import Aboutnew from './components/HomePage/Aboutnew';
import Feature from './components/HomePage/Feature';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Services from './components/HomePage/Services';
import Testimonials from './components/HomePage/Testimonials';


import HomePage from './components/HomePage/HomePage';
import './index.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import FAQs from './components/FAQs/FAQs';
import Careers from './components/Careers/Careers';
import MaxLife from './components/Services/LifeInsurance/MaxLife';
import BajajAlliance from './components/Services/LifeInsurance/BajajAlliance';
import Icici from './components/Services/LifeInsurance/Icici';
import IndiaFirst from './components/Services/LifeInsurance/IndiaFirst';
import Aditya from './components/Services/LifeInsurance/Aditya';
import HDFC from './components/Services/LifeInsurance/HDFC';
import TATA from './components/Services/HealthInsurance/TATA';
import ICICILombard from './components/Services/HealthInsurance/ICICILombard';
import NivaBupa from './components/Services/HealthInsurance/NivaBupa';
import CareHealth from './components/Services/HealthInsurance/CareHealth';

import ScrollToTop from './components/ScrollToTop';
import Sip from './components/Calculator/SIP';
import Swp from './components/Calculator/Swp';
import Creditcard from './components/creditcard/Creditcard';
// import Recruitment from './components/Services/Recruitment/Recruitment';
import Header1 from './components/Header/Header1';
import ProductDetails from './components/Services/ProductDetails';
import EmployeeLogin from './components/Auth/EmployeeLogin';
import ForgotPassword from './components/Auth/ForgotPassword';
import EmployeeDashboard from './components/Employee/EmployeeDashboard';
import JobApplication from './components/Job/JobApplication';
import CustomerLogin from './components/Auth/CustomerLogin';
import CustomerSignup from './components/Auth/CustomerSignup';
import CustomerProfile from './components/Customer/CustomerProfile';
import MyDashboard from './components/Customer/MyDashboard';
import MutualFundCalculator from './components/Services/MutualFundCalculator';
import LifeInsuranceProducts from './components/Services/LifeInsuranceProducts';
import HealthInsuranceProducts from './components/Services/HealthInsuranceProducts';
import MutualFundsProducts from './components/Services/MutualFundsProducts';
import FixedDepositProducts from './components/Services/FixedDepositProducts';
import MotorInsuranceProducts from './components/Services/MotorInsuranceProducts';

import BlogPage from './components/Blog/BlogPage';
import BlogDetail from './components/Blog/BlogDetail';
import AIBot from './components/AIBot/AIBot';



function App() {
  const location = useLocation();
  const hideFooter = location.pathname === '/employee-login' || location.pathname === '/customer-login' || location.pathname === '/customer-signup' || location.pathname === '/employee-dashboard' || location.pathname === '/forgot-password' || location.pathname === '/customer-profile' || location.pathname === '/my-dashboard' || location.pathname === '/products/life-insurance' || location.pathname === '/products/health-insurance' || location.pathname === '/products/mutual-funds' || location.pathname === '/products/fixed-deposit' || location.pathname === '/products/motor-insurance';
  const hideHeader = location.pathname === '/customer-profile' || location.pathname === '/my-dashboard' || location.pathname === '/customer' || location.pathname === '/products/life-insurance' || location.pathname === '/products/health-insurance' || location.pathname === '/products/mutual-funds' || location.pathname === '/products/fixed-deposit' || location.pathname === '/products/motor-insurance';

  return (
    <>
      <ScrollToTop />
      {!hideHeader && <Header1 />}
      <AIBot />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/careers" element={<Careers />} />
         <Route path="/services/product-details/:subcatid" element={<ProductDetails />} />

        <Route path="/services/lifeinsurance/maxlife" element={<MaxLife />} />
        <Route path="/services/lifeinsurance/icici" element={<Icici/>} />
        <Route path="/services/lifeinsurance/bajajalliance" element={<BajajAlliance />} />
        <Route path="/services/lifeinsurance/indiafirst" element={<IndiaFirst />} />
        <Route path="/services/lifeinsurance/aditya" element={<Aditya />} />
        <Route path="/services/lifeinsurance/hdfc" element={<HDFC />} />

        <Route path="/services/healthinsurance/tata" element={<TATA />} />
        <Route path="/services/healthinsurance/icicilombard" element={<ICICILombard />} />
        <Route path="/services/healthinsurance/nivabupa" element={<NivaBupa />} />
        <Route path="/services/healthinsurance/carehealth" element={<CareHealth />} />
        <Route path="/services/creditcard/creditcard" element={<Creditcard />} />
        <Route path="/services/calculator/sip" element={<Sip />} />
        <Route path="/services/calculator/swp" element={<Swp />} />
        {/* <Route path="/services/recruitment/recruitment" element={<Recruitment />} /> */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/employee-login" element={<EmployeeLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        <Route path="/job-application" element={<JobApplication />} />
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route path="/customer-signup" element={<CustomerSignup />} />
        <Route path="/customer-profile" element={<CustomerProfile />} />
        <Route path="/customer" element={<CustomerProfile />} />
        <Route path="/my-dashboard" element={<MyDashboard />} />
        <Route path="/mutual-fund-calculator" element={<MutualFundCalculator />} />
        <Route path="/products/life-insurance" element={<LifeInsuranceProducts />} />
        <Route path="/products/health-insurance" element={<HealthInsuranceProducts />} />
        <Route path="/products/mutual-funds" element={<MutualFundsProducts />} />
        <Route path="/products/fixed-deposit" element={<FixedDepositProducts />} />
        <Route path="/products/motor-insurance" element={<MotorInsuranceProducts />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
